import FetchClient from "./FetchClient";

export interface WootProduct {
  Asin: string;
  root: string;
  updatedAt: number;
  updateTimes: number[];
  inventory: number[];
  salesPrice: number[];
  listPrice: number;
  image: string;
  modifiedAt: string;
  endDate: string;
  isRefurbished: boolean;
  category: string;
  adjustedCategory?: string;
  productCategory: string;
  title: string;
  url: string;
}

export interface WootProductsResponse {
  data: WootProduct[];
  count: number;
}

export async function getRecentWootProducts(): Promise<WootProduct[]> {
  const response = await FetchClient.get<WootProductsResponse>(
    "/woot/products/recent"
  );
  return response.data;
}

export async function sendWootProductToDiscord(asin: string): Promise<void> {
  await FetchClient.post<{ message: string; asin: string }>(
    "/admin/woot/send-to-discord",
    { asin }
  );
}
